//types
import { User, UserFeedbackConfig } from 'types'

export const displayRateAppNotif = (user: User | null, userFeedbackConfig?: UserFeedbackConfig) => {
  if (!user || !userFeedbackConfig) {
    return false
  }
  const isReactNativeApp = Boolean(window.ReactNativeWebView)
  const meetsPiggyBankThreshold =
    user.allTimePiggyBanksEarned >= userFeedbackConfig.piggyBanksEligibilityThreshold
  const hasRedeemedGiftCard = (user.allGiftCardValueRedeemed ?? 0) > 0

  return (
    userFeedbackConfig.serviceEnabled &&
    isReactNativeApp &&
    meetsPiggyBankThreshold &&
    hasRedeemedGiftCard
  )
}
